import React from 'react'
import DetailCard from './DetailCard'
import "./Navbar.css";
import data from '../data/test.json'

const Details = (props) => {
 
  const dataKey = props.id;
  // const data = props.data[dataKey];
  // console.log(data[dataKey]);

  const obj = data[dataKey];

  // const {reqData} = data.dataKey;
  // console.log("Data :" + reqData);

  return (
<div>
<div class="">
        <div className="typewriter-text2 text-center"><h1 className="">{props.id} ACTIVITIES</h1></div>
</div>
<div class="container">
      {/* should be done using map */}

      {obj.map(item => (
          <DetailCard
            key={item.id} // Assuming each item has a unique id
            title={item.title}
            location={item.location}
            date={item.date}
            imageUrl={item.image_url}
            description={item.description}
          />
        ))}
</div>
</div>

  )
}

export default Details
